import ExcelJS from 'exceljs';
import { capitalizeFirstLetter, capitalizeFirstLetterWord } from '../../helpers/commonHelpers';

export const getWorkBook = (sdoMonthlyReports, profileContext) => {
    const workbook = new ExcelJS.Workbook();
    if (Object.keys(sdoMonthlyReports?.sdoSummary).length === 0) return;

    const dataArray = sdoMonthlyReports?.sdoSummary[0] && Object.keys(sdoMonthlyReports?.sdoSummary);
    workbook.addWorksheet("Summary");
    const sheet = workbook.getWorksheet('Summary');
    const exportedBy = "by";
    let date = new Date(sdoMonthlyReports?.exportTimestamp);
    let easterTime = date.toLocaleString('en-GB', { timeZone: 'Canada/Eastern', }).split(",");
    let reportExportedTime = easterTime[1];
    sheet.getRow(1).fill = {
        type: 'pattern',
        pattern: 'solid',
    }

    sheet.getRow(3).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'fff3cc' }
    }
    sheet.getRow(2).height = 18;
    sheet.getRow(2).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'fff3cc' }
    }

    sheet.getCell('A1').value = `SDO Requests - Report`;
    sheet.getCell('A3').value = sdoMonthlyReports?.fileName;
    sheet.getRow(1).font = { size: 26, bold: true, color: { argb: "FFFFFF" } }
    sheet.getRow(2).font = { name: 'Arial Black', color: { argb: '000000' } }
    sheet.getCell('A4').value = 'Total Requests';
    sheet.getCell('B4').value = sdoMonthlyReports?.totalRequests;
    sheet.columns = [
        { key: 'Total Request', width: 52 },
    ]

    sheet.getCell('A5').value = 'Total Approved';
    sheet.getCell('B5').value = sdoMonthlyReports?.totalApproved;

    sheet.getCell('A6').value = 'Total Declined';
    sheet.getCell('B6').value = sdoMonthlyReports?.totalDeclined;

    sheet.getCell('A7').value = 'Total Revoked';
    sheet.getCell('B7').value = sdoMonthlyReports?.totalRevoked;

    sheet.getCell('A9').value = "Average # of SDO's per day";
    sheet.getCell('B9').value = Number(sdoMonthlyReports?.avgSDOPerDay);

    sheet.getCell('A10').value = "Average # of SDO's granted per day";
    sheet.getCell('B10').value = Number(sdoMonthlyReports?.avgSDOGrantedPerDay);

    sheet.getRow(12).font = { bold: true }

    sheet.getCell('A12').value = "Report Exported";
    sheet.getCell('A13').value = `${sdoMonthlyReports?.exportDate} @ ${reportExportedTime} ET`;
    sheet.getCell('A14').value = `${exportedBy} ${capitalizeFirstLetterWord(profileContext.profile.results?.name)}`
    sheet.getRow(3).font = { bold: true, size: 16 }
    sheet.getRow(4).font = { bold: true, color: { argb: "7030A0" }, size: 16 }
    sheet.getRow(5).font = { bold: true, color: { argb: "375623" }, size: 16 }
    sheet.getRow(6).font = { bold: true, color: { argb: "C00000" }, size: 16 }
    sheet.getRow(7).font = { bold: true, color: { argb: "808080" }, size: 16 }
    sheet.getRow(9).font = { bold: true, size: 16 }
    sheet.getRow(10).font = { bold: true, size: 16 }
    sheet.getRow(12).font = { bold: true, size: 12 }
    sheet.getRow(13).font = { size: 12 }
    sheet.getRow(14).font = { size: 12 }


    //summary ends//

    dataArray.forEach(dataInfo => {
        workbook.addWorksheet(sdoMonthlyReports.sdoSummary[dataInfo][0].title)
        let sheetTwo = workbook.getWorksheet(sdoMonthlyReports.sdoSummary[dataInfo][0].title)
        sheetTwo.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
        }
        sheetTwo.getRow(7).fill = {
            type: 'pattern',
            pattern: 'solid',
        }

        const sdoRequests = "SDO Requests:";
        const sdoTitle = sdoMonthlyReports.sdoSummary[dataInfo][0].title.replace(/-/g, '|')

        sheetTwo.getCell('A1').value = `${sdoRequests} ${sdoTitle}`
        sheetTwo.getRow(1).height = 40;
        sheetTwo.getRow(1).font = { size: 28, bold: true, color: { argb: "FFFFFF" } };
        sheetTwo.getRow(7).font = { size: 14, bold: true, color: { argb: "FFFFFF" } };

        sheetTwo.getRow(2).font = { bold: true, color: { argb: "7030A0" }, size: 16 }
        sheetTwo.getRow(3).font = { bold: true, color: { argb: "375623" }, size: 16 }
        sheetTwo.getRow(4).font = { bold: true, color: { argb: "C00000" }, size: 16 }
        sheetTwo.getRow(5).font = { bold: true, color: { argb: "808080" }, size: 16 }

        sheetTwo.mergeCells('A2', 'B2')
        sheetTwo.mergeCells('A3', 'B3')
        sheetTwo.mergeCells('A4', 'B4')
        sheetTwo.mergeCells('A5', 'B5')
        sheetTwo.getRow(7).values = ['Base', 'Equip', 'Rank', 'Pilot', 'Employee ID', 'Seniority', 'AQ', 'Block Month', 'Dates Requested', '# of Days', 'Decision', 'Reason', 'Reviewer/Adminstrator', 'Published/Modified', 'Comment'];

        sheetTwo.columns = [
            { key: 'base', width: 13 },
            { key: 'equip', width: 8 },
            { key: 'rank', width: 8 },
            { key: 'pilot', width: 32 },
            { key: 'empid', width: 16 },
            { key: 'seniority', width: 18 },
            { key: 'aq', width: 6 },
            { key: 'blockMonth', width: 23 },
            { key: 'dateRequest', width: 33 },
            { key: 'noOfDay', width: 13 },
            { key: 'decision', width: 13 },
            { key: 'reason', width: 19 },
            { key: 'reviewer', width: 29 },
            { key: 'published', width: 30 },
            { key: 'comment', width: 77 }
        ]
        let revoked = 0;
        let declined = 0;
        let award = 0;

        sdoMonthlyReports.sdoSummary[dataInfo].forEach(item => {
            sheetTwo.addRow({
                base: item.pos.base,
                equip: item.pos.equipment,
                rank: item.rank,
                pilot: capitalizeFirstLetterWord(item.pilot),
                empid: item.employee_id,
                seniority: item.seniority,
                aq: item?.AQ === 'null' ? '' : item?.AQ,
                blockMonth: item?.block_month,
                dateRequest: item?.date_requested,
                noOfDay: item.no_of_days,
                decision: item?.decision,
                reason: item?.reason.toLowerCase() === 'n/a' ? "N/A" : capitalizeFirstLetter(item?.reason.toLowerCase()),
                reviewer: capitalizeFirstLetterWord(item?.published_by),
                published: item?.published_on,
                comment: item?.comments
            })
                .alignment = { horizontal: 'left' }
            const decision = sheetTwo.getColumn('decision')
            decision.eachCell((cell, rowNumber) => {
                if (cell.value === 'APPROVED') {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'e2efda' }

                    };
                } else if (cell.value === 'DECLINED') {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'f8cbad' }

                    };
                } else if (cell.value === 'REVOKED') {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'd0cdce' }

                    };
                }
            });

            if (item?.decision === "REVOKED") {
                revoked = revoked + 1;
            }
            if (item?.decision === "DECLINED") {
                declined = declined + 1;
            }
            if (item?.decision === "APPROVED") {
                award = award + 1;
            }
        })

        sheetTwo.getCell('A2').value = "Total Requests";
        sheetTwo.getCell('C2').value = (award + declined + revoked);

        sheetTwo.getCell('A3').value = "Total Approved";
        sheetTwo.getCell('C3').value = award;

        sheetTwo.getCell('A4').value = "Total Declined";
        sheetTwo.getCell('C4').value = declined;

        sheetTwo.getCell('A5').value = "Total Revoked";
        sheetTwo.getCell('C5').value = revoked;

    })

    return workbook;
}

// File title: ‘SDO Requests - [BlockMonth] [YYYY] - [export date MMM DD, yyyy]’ ie. 'SDO Requests - September 2022 - Oct 03, 2022' 
const getFileName = (sdoMonthlyReportsData) => {
    if (!sdoMonthlyReportsData) return;
    return `${'SDO Requests'} - ${sdoMonthlyReportsData?.fileName.split(' ')[0]} ${sdoMonthlyReportsData?.fileName.split(' ')[1]} - ${sdoMonthlyReportsData?.exportDate}`;
}

export const download = async (format, workbook, sdoMonthlyReportsData) => {
    if (Object.keys(sdoMonthlyReportsData?.sdoSummary).length === 0) return;
    const uint8Array =
        format === "xlsx"
            ? await workbook.xlsx.writeBuffer() : '';
    const blob = new Blob([uint8Array], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', `${getFileName(sdoMonthlyReportsData)}${'.'}` + format);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};